<template>
  <div>
    <div class="pagination-wrapper">
      <div class="page-button" @click="activeToPage(1)">
        <span class="fontS">&lt;&lt;</span>
      </div>
      <div class="page-button" @click="activeToPage(activePage - 1)">
        <span class="fontS">&lt;</span>
      </div>
      <div v-for="(value, index) in getRange()" :key="index">
        <div
          class="page-button"
          @click="activeToPage(value)"
          :class="{active: value === activePage}"
        >
          <span class="fontS">
            {{ value }}
          </span>
        </div>
      </div>
      <div class="page-button" @click="activeToPage(activePage + 1)">
        <span class="fontS">&gt;</span>
      </div>
      <div class="page-button" @click="activeToPage(totalPageCount)">
        <span class="fontS">&gt;&gt;</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalPageCount: Number,
    totalDataCount: Number,
  },
  data() {
    return {
      activePage: 1,
      pageIndexCount: 5,
    };
  },
  methods: {
    activeToPage(page) {
      page = page <= 0 ? 1 : page;
      page = page >= this.totalPageCount ? this.totalPageCount : page;
      this.activePage = page;
      this.getRange();
      // 위로 emit만 해주면 끝
      this.$emit("change-page", this.activePage);
    },
    getRange() {
      let firstIndex = Math.max(1, this.activePage - 2);

      firstIndex = Math.min(
        firstIndex,
        Math.max(this.totalPageCount - this.pageIndexCount + 1, 1)
      );

      let result = [];
      let pageCount = Math.min(this.totalPageCount, this.pageIndexCount);
      for (let i = 0; i < pageCount; i++) {
        result.push(firstIndex + i);
      }
      return result;
    },
  },
};
</script>

<style scoped>
.pagination-wrapper {
  display: flex;
  justify-content: center;
  padding: 2rem 0 0;
}
.active {
  color: white;
  background-color: #ff5230;
  border: 1px solid #ff5230 !important;
}
.page-button span {
  font-size: 14px;
}
.page-button {
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 1rem; */
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: 1px solid #dddddd;
  margin: 0 5px;
}
</style>
